export default __webpack_public_path__ + "static/media/bike.2d0f6d30.jpeg";